import { DefaultFilter, DefaultFilterValidation, DefaultFilterMetadata } from './types-store';

export const ACTION = {
  REQUEST_FILTER_METADATA: 'DEFAULT_FILTERS:REQUEST_FILTER_METADATA',
  RECEIVE_FILTER_METADATA: 'DEFAULT_FILTERS:RECEIVE_FILTER_METADATA',
  FAIL_FILTER_METADATA: 'DEFAULT_FILTERS:FAIL_FILTER_METADATA',

  ADD_FILTERS: 'DEFAULT_FILTERS:ADD_FILTERS',
  UPDATE_FILTER: 'DEFAULT_FILTERS:UPDATE_FILTER',
  DELETE_FILTER: 'DEFAULT_FILTERS:DELETE_FILTER',
  DELETE_ALL_FILTERS: 'DEFAULT_FILTERS:DELETE_ALL_FILTERS',

  UPDATE_VALIDATION: 'DEFAULT_FILTERS:UPDATE_VALIDATION'
};

export class RequestFilterMetadata {
  public type: string = ACTION.REQUEST_FILTER_METADATA;
  constructor(
    public component: string,
    public domainIds: number[]
  ) { }
}

export class ReceiveFilterMetadata {
  public type: string = ACTION.RECEIVE_FILTER_METADATA;
  constructor(
    public component: string,
    public domainIds: number[],
    public filterMetadata: DefaultFilterMetadata[]
  ) { }
}

export class FailFilterMetadata {
  public type: string = ACTION.FAIL_FILTER_METADATA;
  constructor(
    public component: string,
    public domainIds: number[]
  ) { }
}

export class AddFilters {
  public type: string = ACTION.ADD_FILTERS;
  constructor(
    public component: string,
    public filters: DefaultFilter[]
  ) { }
}

export class UpdateFilter {
  public type: string = ACTION.UPDATE_FILTER;
  constructor(
    public component: string,
    public domainId: number,
    public filter: DefaultFilter,
    public validation: DefaultFilterValidation
  ) { }
}

export class DeleteFilter {
  public type: string = ACTION.DELETE_FILTER;
  constructor(
    public component: string,
    public domainId: number
  ) { }
}

export class DeleteAllFilters {
  public type: string = ACTION.DELETE_ALL_FILTERS;
  constructor(
    public component: string
  ) { }
}

export class UpdateFiltersValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(
    public component: string,
    public filterValidation: { [domainId: number]: DefaultFilterValidation }
  ) { }
}
